<template>
  <div id="signup">
     <body class="login-page err-500">
          <div class="container">
            <div class="login-container">
                <div class="row">
                    <div class="col-lg-4 col-md-5 col-sm-9 lfh">
                        <div class="card login-box">
                            <div class="card-body">
                                <h5 class="card-title">Sign Up</h5>
                                <loading :active.sync="isLoading" 
                                  :can-cancel="true" 
                                  :is-full-page="fullPage"></loading>
                                <form novalidate="true" @keyup.enter="signup(e)">
                                <p style="color:red;text-align:center">{{ errorMessage }}</p>
                                  <p v-if="errors.length">
                                  <!-- <ul>
                                  <li style='color:red' v-for="error in errors">{{ error }}</li>
                                  </ul> -->
                                  <p style='color:red;text-align:center' v-for="error in errors"> {{ error }}</p>
                                  </p>
                                    <div class="form-group">
                                        <input type="email" class="form-control" ref="email" name="email" v-model="input.email"  id="exampleInputEmail" aria-describedby="emailHelp" placeholder="Enter email">
                                    </div>
                                    <div class="form-group">
                                        <input type="text" class="form-control" ref="firstname" name="firstname" v-model="input.firstname" id="firstname" aria-describedby="firstname" placeholder="Firstname">
                                    </div>
                                     <div class="form-group">
                                        <input type="text" class="form-control" ref="lastname" name="lastname" v-model="input.lastname" id="lastname" aria-describedby="lastname" placeholder="Lastname">
                                    </div>
                                    <div class="form-group">
                                        <input type="text" class="form-control" ref="username" name="username" v-model="input.username" id="userName" aria-describedby="userName" placeholder="Username">
                                    </div>
                                    <div class="form-group">
                                        <input type="password" class="form-control" ref="password" name="password" v-model="input.password" id="exampleInputPassword" placeholder="Password">
                                    </div>
                                    <div class="form-group">
                                        <input type="password" class="form-control" ref="cnfpassword" name="cnfpassword" v-model="input.cnfpassword" id="exampleInputCnfpassword" placeholder="Confirm Password">
                                    </div>
                                    <div class="custom-control custom-checkbox form-group">
                                        <input type="checkbox" class="custom-control-input" id="termsandcond" v-on:click="checkboxClick()">
                                        <label class="custom-control-label" for="termsandcond">I Agree with <a href="https://www.tallyinvoice.com/terms" target="_blank">Terms &amp; Policies</a></label>
                                    </div>
                                    <!--<a href="#" class="btn btn-primary">Sign Up</a>-->
                                    <button type="button" id="signup_btn" class="btn btn-primary btn-lg" v-on:click="signup()">Sign Up</button>
                                    <!--<a href="sign-in.html" class="btn btn-secondary">Sign In</a>-->
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
          </div>
      </body>
  </div>
</template>
<script>
  import axios from 'axios'
  import Loading from 'vue-loading-overlay'
  import 'vue-loading-overlay/dist/vue-loading.css'
  export default {
    name: 'Escrow',
    components: {
      Loading
    },
    data () {
      return {
        errors: [],
        errorMessage: '',
        isLoading: false,
        fullPage: true,
        input: {
          email: '',
          firstname: '',
          lastname: '',
          username: '',
          password: '',
          cnfpassword: ''
        }
      }
    },
    methods: {
      signup () {
        this.errors = []
        var pass = this.input.password
        var firstname = this.input.firstname
        var lastname = this.input.lastname
        var uname = this.input.username
        var x = this.input.email
        var atposition = x.indexOf('@')
        var dotposition = x.lastIndexOf('.')
        var checkBox = document.getElementById('termsandcond')
        if (x === '') {
          this.errors.push('Email is Required')
          this.$refs.email.focus()
        } else if (atposition < 1 || dotposition < atposition + 2 || dotposition + 2 >= x.length) {
           this.errors.push('Please enter a valid e-mail address ')
           this.$refs.email.focus()
        } else if (this.input.firstname === '') {
          this.errors.push('Firstname is Required')
          this.$refs.firstname.focus()
        } else if (firstname.length < 3) {
          this.errors.push('Firstname must be 5 characters long')
          this.$refs.firstname.focus()
        } else if (this.input.username === '') {
          this.errors.push('Username is Required')
          this.$refs.username.focus()
        } else if (uname < 3) {
          this.errors.push('Username must be 5 characters long')
          this.$refs.username.focus()
        } else if (this.input.password === '') {
          this.errors.push('Password is Required')
          this.$refs.password.focus()
        } else if (pass.length < 6) {
          this.errors.push('Password must be 6 characters long')
          this.$refs.password.focus()
        } else if (this.input.cnfpassword === '') {
          this.errors.push('Confirm Password is Required')
          this.$refs.cnfpassword.focus()
        } else if (this.input.password !== this.input.cnfpassword) {
          this.errors.push('Password & Confirm Password does not matched')
          this.$refs.cnfpassword.focus()
        } else if(!checkBox.checked) {
          this.errors.push('Please agree terms and conditions')
        }else{
          this.isLoading = true
          var email = this.input.email
          var username = this.input.username
          var firstname = this.input.firstname
          var lastname = this.input.lastname
          var password = this.input.password
          var confirmpassword = this.input.cnfpassword
          axios.post('https://us-central1-stripe-firebase-133c0.cloudfunctions.net/escrowSignup',
            {
              email: email,
              firstname: firstname,
              lastname: lastname,
              username: username,
              password: password,
              confirm_password: confirmpassword
            })
            .then(response =>
             {
              this.isLoading = false
               var uid = response.data.results[0].uid
               //console.log(userID)
               localStorage.setItem('uid',uid) 
               window.open('https://connect.stripe.com/express/oauth/authorize?response_type=code&client_id=ca_GVYn1wmqiX7xBr65utC44cXRFRMirGLR&scope=read_write&requested_capabilities=["card_payments","transfers"]&requested=true#/', '_self')
             })
            .catch((error) => {
              this.errorMessage = error.response.data.errors
              this.isLoading = false
            })
        }
      },
      checkboxClick () {
        var checkBox = document.getElementById('termsandcond')
        if (checkBox.checked === true) {
          document.getElementById('signup_btn').disabled = false
        } else {
          document.getElementById('signup_btn').disabled = true
        }
      }
    },
    mounted () {
      document.getElementById('signup_btn').disabled = true
      var uid = this.$route.query.uid
      var self = this
      axios.get('https://us-central1-stripe-firebase-133c0.cloudfunctions.net/getUserById/?uid=' + uid)
        .then(response => {
          var email = response.data.results[0].email
          localStorage.setItem('email', email)
          localStorage.setItem('uid', uid)
          self.input.email = email
        })
        .catch((error) => {
          this.errorMessage = error.response.data.errors
          this.isLoading = false
        })
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Escrow.vue